import React from 'react';
import PropTypes from 'prop-types';
import _startCase from 'lodash/startCase';
import { Button, Typography, LazyLoadImage } from 'ck-ui';
import { getBrandImageUrl } from 'ck-utils';
import { tagsToHandlesAndLabels } from 'ck-utils/tags';
import styles from './PDPViewMoreButtons.module.scss';

const PDPViewMoreButtons = ({ tags }) => {
  // Tracking click handler

  const {
    brand,
    gender,
    categoryHandle,
    categoryLabel,
    subCategoryHandle,
    subCategoryLabel,
    category,
    isRareCategory
  } = tagsToHandlesAndLabels(tags);

  // Prepare data for the rendering
  const buttons = [
    {
      handle: gender && gender !== 'na' && brand && `${gender}-${brand}`,
      isPrimary: true,
      className: styles.brand,
      label: 'Shop More From:',
      suffix: <LazyLoadImage className={styles.brandImage} alt={brand} src={getBrandImageUrl(brand)} />
    },
    {
      handle: subCategoryHandle,
      label: `Shop More ${subCategoryLabel}`,
    },
    {
      handle: categoryHandle,
      label: `Shop More ${categoryLabel}`,
    },
    {
      handle: gender && gender !== 'na' && (isRareCategory ? `${gender}-new-arrivals` : `new-arrivals-${gender}-${category}`),
      label: 'Shop More New Arrivals'
    }
  ];

  return (
    <div className="container">
      <Typography
        renderAs="h2"
        variant="heading5"
        align="centered"
        className={styles.title}
      >
        Check out this heat <span role="img" aria-label="heat">🔥</span>
      </Typography>
      <div className="columns is-multiline is-centered is-vcentered mt-4">
        {buttons.map(button => (button.handle ? (
          <div key={button.handle} className="column is-half-tablet is-one-quarter-desktop has-text-centered">
            <Button
              secondary={!button.isPrimary}
              fullwidth="all"
              renderAs="a"
              href={`/collections/${button.handle}`}
              title={_startCase(button.handle)}
              size="large"
              suffix={button.suffix}
              className={button.className}
            >
              {button.label}
            </Button>
          </div>
        ) : null))}
      </div>
    </div>
  );
};

PDPViewMoreButtons.propTypes = {
  tags: PropTypes.array.isRequired,
};

export { PDPViewMoreButtons };
